import posthog from "posthog-js";

/**
 * PostHog analytics.
 *
 * To enable, add `VITE_POSTHOG_TOKEN` (and optionally `VITE_POSTHOG_HOST`)
 * to the project environment. Without a key, all calls are no-ops so the
 * app continues to work in development and during preview.
 */
let initialized = false;

export function initAnalytics() {
  if (initialized) return;
  if (typeof window === "undefined") return;
  const key = import.meta.env.VITE_POSTHOG_TOKEN as string | undefined;
  if (!key) return;
  const host =
    (import.meta.env.VITE_POSTHOG_HOST as string | undefined) ||
    "https://app.posthog.com";
  posthog.init(key, {
    api_host: host,
    capture_pageview: true,
    capture_pageleave: true,
  });
  initialized = true;
}

export function track(event: string, props?: Record<string, unknown>) {
  if (!initialized) return;
  try {
    posthog.capture(event, props);
  } catch {
    // ignore
  }
}

export function identify(userId: string, props?: Record<string, unknown>) {
  if (!initialized) return;
  try {
    posthog.identify(userId, props);
  } catch {
    // ignore
  }
}

export function resetAnalytics() {
  if (!initialized) return;
  try {
    posthog.reset();
  } catch {
    // ignore
  }
}